export type IconVariants =
  | 'activity'
  | 'barChart'
  | 'bag'
  | 'danger'
  | 'eye'
  | 'clock'
  | 'gallery'
  | 'game'
  | 'gift'
  | 'location'
  | 'pieChart'
  | 'star'
  | 'user'
  | 'video'
  | 'wallet'
  | 'walletChart'
  | 'walletPlus'
  | 'walletEdit'
  | 'filterGray'
  | 'closeGray'
  | 'cross'
  | 'ctv'
  | 'phone'
  | 'paper'
  | 'lannerFormat'
  | 'videoFormat'
  | 'thematicPackages'
  | 'thematicCluster';

export const ICON_VARIANTS: Record<IconVariants, IconVariants> = {
  activity: 'activity',
  barChart: 'barChart',
  bag: 'bag',
  danger: 'danger',
  eye: 'eye',
  clock: 'clock',
  gallery: 'gallery',
  game: 'game',
  gift: 'gift',
  location: 'location',
  pieChart: 'pieChart',
  star: 'star',
  user: 'user',
  video: 'video',
  wallet: 'wallet',
  walletChart: 'walletChart',
  walletPlus: 'walletPlus',
  walletEdit: 'walletEdit',
  filterGray: 'filterGray',
  closeGray: 'closeGray',
  cross: 'cross',
  ctv: 'ctv',
  phone: 'phone',
  paper: 'paper',
  lannerFormat: 'lannerFormat',
  videoFormat: 'videoFormat',
  thematicPackages: 'thematicPackages',
  thematicCluster: 'thematicCluster',
};
